import { render } from "./SelectInput.vue?vue&type=template&id=4f65f736&scoped=true&bindings={\"modelValue\":\"props\",\"name\":\"props\",\"label\":\"props\",\"includeBlank\":\"props\",\"options\":\"props\",\"changeValue\":\"setup\",\"handleBlur\":\"setup\",\"meta\":\"setup\",\"errorMessage\":\"setup\",\"selectedKey\":\"setup\",\"opts\":\"setup\"}"
import script from "./SelectInput.vue?vue&type=script&lang=js"
export * from "./SelectInput.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4f65f736"

export default script